import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

import { getCommentsRes } from "core/http/service/news/resTypes";

interface InitialState {
  status: ReduxStateType;
  data: getCommentsRes;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: {
    data: [],
    totalRecords: 0,
  },
};

const getCommentsSlice = createSlice({
  name: "getComments",
  initialState,
  reducers: {
    getCommentsStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getCommentsSuccess: (state, action: PayloadAction<getCommentsRes>) => {
      state.status = ReduxStateType.SUCCESS;
      const { data } = action.payload;

      state.data = { ...action.payload, data: [...state.data.data, ...data] };
    },
    getCommentsFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetComments: () => {
      return { ...initialState };
    },
  },
});

export const {
  getCommentsStart,
  getCommentsSuccess,
  getCommentsFailed,
  resetComments,
} = getCommentsSlice.actions;

export default getCommentsSlice.reducer;
